import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SiteSequencerComponent } from './components/site-sequencer/site-sequencer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { ConfigurationService } from './services/configuration.service';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { JwtInterceptor } from './services/jwt.interceptor.service';
import { HttpCancelInterceptor } from './services/cancel.interceptor.service';
import { FormsModule } from '@angular/forms';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { CommentsLayoutWrapperComponent } from './shared/components/comments-layout-wrapper/comments-layout-wrapper.component';
import { ConfigurationCommentsService } from '@75f/comments';
import { CommonTooltipComponent } from './shared/components/common-tooltip/common-tooltip.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { SiteSelectionDropdownComponent } from './shared/components/site-selection-dropdown/site-selection-dropdown.component';

const appInitializerFn = (
  appConfig: ConfigurationService,
  commentsConfig: ConfigurationCommentsService
  ) => {
  return () => {
      const config = environment.config;
      commentsConfig.setConfig(config);
      appConfig.setConfig(config);
  };
};

@NgModule({
  declarations: [
    AppComponent,
    SiteSequencerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    ScrollingModule,
    CodemirrorModule,
    CommentsLayoutWrapperComponent,
    CommonTooltipComponent,
    NgSelectModule,
    CommonModule,
    SiteSelectionDropdownComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      deps: [ConfigurationService, ConfigurationCommentsService],
      multi: true
    },
    { provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
    { provide: 'WINDOW', useFactory: getWindow },
    { provide: ConfigurationService, useClass: ConfigurationService },
    { provide: ConfigurationCommentsService, useClass: ConfigurationCommentsService },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpCancelInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function getLocalStorage() {
  return (typeof window !== "undefined") ? window.sessionStorage : null;
}

export function getWindow(): any {
  return (typeof window !== "undefined") ? window : {};
}